export class Device {
  address: string;
  id: string;
  serialNumber: string;
  webObjectId: string;
  ipMachine: string

  constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/model/device.ts